import { useState } from 'react';
import { api } from '@/lib/api';

interface ExplainParam {
  key: string;
  label: string;
  value: string;
  category: string;
}

export function useExplain() {
  const [open, setOpen] = useState(false);
  const [param, setParam] = useState<ExplainParam | null>(null);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);

  async function explain(key: string, label: string, value: string, category: string) {
    setParam({ key, label, value, category });
    setText('');
    setLoading(true);
    setOpen(true);
    try {
      const res = await api.post<{ explanation: string }>('/api/settings/explain', {
        key, label, value, category,
      });
      setText(res.explanation);
    } catch {
      setText('Unable to fetch explanation. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return { open, setOpen, param, text, loading, explain };
}
